import * as signalR from '@microsoft/signalr';

const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5176').replace(/\/api\/?$/, '');
const HUB_URL = API_BASE + '/hubs/chat';

let connection = null;

export const signalRService = {
    async start() {
        if (connection && connection.state === signalR.HubConnectionState.Connected) return;

        connection = new signalR.HubConnectionBuilder()
            .withUrl(HUB_URL, {
                accessTokenFactory: () => localStorage.getItem('token'),
            })
            .withAutomaticReconnect()
            .build();

        await connection.start();
    },

    async stop() {
        if (connection) {
            await connection.stop();
            connection = null;
        }
    },

    on(event, callback) {
        if (connection) connection.on(event, callback);
    },

    off(event, callback) {
        if (connection) connection.off(event, callback);
    },

    async invoke(method, ...args) {
        if (connection) await connection.invoke(method, ...args);
    },

    getState() {
        return connection?.state ?? signalR.HubConnectionState.Disconnected;
    }
};
